export default __webpack_public_path__ + "static/media/map-pin-location-past-days.97dfec9f.svg";